<!-- Общие вкладки списка и настроек с сохранением существующих URL. -->
<template>
  <nav class="notification-navigation" aria-label="Разделы уведомлений">
    <BaseTabs
      :tabs="navigationTabs"
      :model-value="$route.name"
      @update:model-value="openTab"
      @middle-click="openNewTab"
    />
  </nav>
</template>

<script>
import { nextTick } from "vue";

export default {
  name: "NotificationNavigation",
  props: {
    embedded: { type: Boolean, default: false },
  },
  data() {
    return {
      tabs: [
        { key: "Notifications", label: "Уведомления", iconName: "bell" },
        { key: "NotificationSettings", label: "Настройки уведомлений", iconName: "settings" },
      ],
    };
  },
  computed: {
    navigationTabs() {
      return this.tabs.map((tab) => ({
        ...tab,
        ariaCurrent: tab.key === this.$route.name ? "page" : undefined,
      }));
    },
  },
  methods: {
    async openTab(name) {
      if (name === this.$route.name) return;
      const hadFocus = this.$el.contains(document.activeElement);
      const container = this.$el.closest(".base-modal, .content");
      // Вкладки модалки не добавляют шагов перед возвратом на исходную страницу.
      if (this.embedded) await this.$router.replace({ name });
      else await this.$router.push({ name });
      await nextTick();
      // Router заменяет навигацию; не оставляем клавиатуру на body после перехода.
      if (hadFocus && container?.isConnected && document.activeElement === document.body) {
        container.querySelector('.notification-navigation [aria-current="page"]')?.focus();
      }
    },
    openNewTab({ key }) {
      window.open(this.$router.resolve({ name: key }).href, "_blank", "noopener");
    },
  },
};
</script>

<style scoped>
.notification-navigation {
  margin-bottom: 16px;
}
</style>
